export abstract class ILogger {
  abstract debug(msg: string, ...details: unknown[]): void;
  abstract info(msg: string, ...details: unknown[]): void;
  abstract warn(msg: string, ...details: unknown[]): void;
  abstract error(msg: string, ...details: unknown[]): void;
}
